module.exports = __webpack_public_path__ + "static/media/logo-vale.9c60bc11.svg";